<!--
 * @Author: your name
 * @Date: 2021-09-26 11:35:24
 * @LastEditTime: 2022-12-22 14:15:38
 * @LastEditors: shijian.chen shijian.chen@qunar.com
 * @Description: In User Settings Edit
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/lianhua_test/components/videoComp.vue
-->
<!--
    视频模块
-->
<template>
    <div class="video">
        <div id="video">
            <video data-v-3b1260f5="" id="vido_one" :src="src"
            controls="controls"
            webkit-playsinline="" :poster="poster"
            playsinline="" x5-video-player-type="h5" class="video__player poster">
                抱歉，您的浏览器不支持内嵌视频
            </video>
        </div>  
    </div>
</template>
<script>
    export default {
        props:['src','poster']
    }
</script>
<style lang="less" scoped>
    .video{
        display:flex;
        align-items: center;
        justify-content: center;
        margin:0 auto;
        border-radius: 5px;
        video{
            width:100%;
            height: 214px;
            margin-left:auto;
            margin-right:auto;
            border-radius: 5px;
        }
    }
</style>